import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {InviteV2} from '../models/invite-v2';
import {MatTableDataSource} from '@angular/material/table';
import {Member} from '../models/member';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {EmailService} from './email.service';
import {Agenda} from '../models/agenda';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {Router} from '@angular/router';
import {CryptoService} from './crypto.service';
import {MemberTempService} from './member-temp.service';

@Injectable({
  providedIn: 'root'
})
export class InviteV2Service {

  //public inviteDisplayColumns: string[] = [ 'member_name', 'date_sent', 'accept', 'delete', 'select', 'edit' ];

  public invitesDataSource: MatTableDataSource<any>;
  public invitesDisplayColumns: string[] = [ 'staff_name', 'confirm', 'date_sent', 'date_response', 'accept', 'delete', 'edit', 'select' ];

  public responsesDataSource: MatTableDataSource<any>;
  public responsesArchivedDataSource: MatTableDataSource<any>;

  public reponsesDisplayColumns: string[] = [ 'member_name_response' ];

  public spinner: boolean;

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  public memberForm: FormGroup;

  constructor (
    public _emailService: EmailService,
    private fs: AngularFireStorage,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService,
    private fb: FormBuilder,
    private router: Router,
    private _cryptoService: CryptoService,
    private _memberTempService: MemberTempService
  ) {

  }

  select () {
    // console.log("selectByEvent ------------------------")
    return this.db.collection<InviteV2>('sbccv_invites_v2').snapshotChanges();
  }

  getById (id) {
    return this.db.doc<InviteV2>('sbccv_invites_v2/' + id)
      .get();
  }

  selectByEventAndLetter (event_id, letter_id) {
    // console.log("selectByEvent ------------------------")
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where('event_id', '==', event_id)
      .where('letter_id', '==', letter_id)
    ).snapshotChanges();

  }

  compareMemberNames (a, b) {
    if (a.member_name > b.member_name) return 1;
    if (b.member_name > a.member_name) return -1;
    return 0;
  }

  insert (entity: InviteV2) {

    console.log("invite: " + JSON.stringify(entity))
    return this.db.collection('sbccv_invites_v2').add(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_invites_v2').doc(entity_id).delete();
  }

  selectByInvite (member_id, letter_id, event_id) {
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where('member_id', '==', member_id)
      .where('letter_id', '==', letter_id)
      .where('event_id', '==', event_id)
    ).get();
  }

  selectByMemberLetterEvent (member_id, letter_id, event_id) {
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where('member_id', '==', member_id)
      .where('letter_id', '==', letter_id)
      .where('event_id', '==', event_id)
    ).get();
  }

  registerResponse (invite_id: any, updatedData: any) {
    this.spinner = true;

    return this.db.collection('sbccv_invites_v2').doc(invite_id)
      .set(Object.assign({}, updatedData), {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("ERRO " + JSON.stringify(error));
        this.snackBar.openSnackBar("erro ao atualizar convite", '', 'error');
      })
      .finally(() => {
        this.spinner = false
      })
  }

  selectInvites (event_id) {
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where("event_id", "==", event_id)
      .orderBy('member_name', 'asc')).snapshotChanges();

  }

  ///////////////////////////

  makeURL (data: any) {

    const invite = data.invite
    const letter = data.letter
    const event = data.event

    let url_typed: string;

    if (letter.type == '0') { // confirmação
      url_typed = "https://sbccv-proj.firebaseapp.com/confirm_back_v2/"
    } else if (letter.type == '1') {// atualizar
      url_typed = "https://sbccv-proj.firebaseapp.com/update_back_v2/"
    }

    let url_back: any = ""
    url_back += url_typed
    url_back += invite.member_id + ":"
    url_back += letter.id + ":"
    url_back += event.id;

    return url_back;
  }

  makeEmail (invite: any, letter: any, url_back: string) {

    //  console.log("invite: " + JSON.stringify(invite.agenda))

    let link_resposta = ""
    link_resposta += "<a href='" + url_back + "'>";

    if (invite.type == '0') {
      link_resposta += "Clique aqui para registrar sua resposta.";
    } else if (invite.type == '1') {
      link_resposta += "Clique aqui para revisar seus dados.";
    }

    link_resposta += "</a>";

    let resumo_atividade: string = "";

    invite.agenda.forEach(appointment => {

      resumo_atividade += "<ul>";

      resumo_atividade += "<div>";
      resumo_atividade += "<span>" + appointment.role_name + "</span>";
      if (appointment.level == 't') {
        resumo_atividade += "<span> no tópico</span>";
      } else if (appointment.level == 'a') {
        resumo_atividade += "<span> na atividade</span>";
      }
      resumo_atividade += "</div>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Data: </div>";
      resumo_atividade += "<div>" + this.formatDate(appointment.day_date) + "</div>";
      resumo_atividade += "</li>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Departamento: </div>";
      resumo_atividade += "<div>" + appointment.depto_name + "</div>";
      resumo_atividade += "</li>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Atividade: </div>";
      resumo_atividade += "<div>" + appointment.activity_startTime + " - " + appointment.activity_name + "</div>";
      resumo_atividade += "</li>";

      if (appointment.level == 't') {

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Tópico: </div>";
        resumo_atividade += "<div>" + appointment.topic_startTime + " - " + appointment.topic_name + "</div>";
        resumo_atividade += "<div>" + appointment.topic_duration + " minutos" + "</div>";
        resumo_atividade += "</li>";

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Equipe do Tópico</div>"

        appointment.topicStaff.forEach(st => {
          resumo_atividade += "<div style='margin-left:20px;'>";
          if (invite.member_name == st.member_name) {
            resumo_atividade += st.role_name + " - " + "<span style='color:rgb(0,0,220);'>" + st.member_name + "</span>";
          } else {
            resumo_atividade += st.role_name + " - " + st.member_name;
          }
          resumo_atividade += "</div>";
        });
        resumo_atividade += "</li>";

        resumo_atividade += "<hr>";
      }


      if (appointment.level == 'a') {
        resumo_atividade += "<ul>";
        resumo_atividade += "<div>Equipe da atividade</div>";

        appointment.activityStaff.forEach(st => {
          resumo_atividade += "<li>";
          if (invite.member_name == st.member_name) {
            resumo_atividade += st.role_name + " - " + "<span style='color:rgb(0,0,220);'>" + st.member_name + "</span>";
          } else {
            resumo_atividade += st.role_name + " - " + st.member_name;
          }
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";

        resumo_atividade += "<hr>";

        resumo_atividade += "<ul>"
        appointment.activityTopics.forEach(ac => {
          resumo_atividade += "<li>";
          resumo_atividade += ac.topic_startTime + " - " + ac.topic_name;
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";
      }

      resumo_atividade += "</ul>";
    });

    // realiza as substituições das tgs pelos seus valores reais
    let temp_text = letter.text;

    if (letter.imageTop) {
      temp_text = temp_text.replace('[imagem_1]', "<img src='" + letter.imageTop + "'>")
    }
    else {
      temp_text = temp_text.replace('[imagem_1]', "")
    }

    if (letter.imageBottom) {
      temp_text = temp_text.replace('[imagem_2]', "<img src='" + letter.imageBottom + "'>")
    } else {
      temp_text = temp_text.replace('[imagem_2]', "")
    }

    if (letter.imageBody) {
      temp_text = temp_text.replace('[imagem_corpo]', "<img src='" + letter.imageBody + "'>")
    } else {
      temp_text = temp_text.replace('[imagem_corpo]', "")
    }

    temp_text = temp_text.replace('[nome_associado]', invite.member_name)
    temp_text = temp_text.replace('[link_resposta]', link_resposta)
    temp_text = temp_text.replace('[resumo_atividade]', resumo_atividade)

    return "<div>" + temp_text + "</div>";

  }

  makeInvite (data: any, url_back: string, member_email: string, html_email: string, obs: string, admin_invite: boolean, memberDataCheck: any = null) {

    const letter: any = data.letter
    const event: any = data.event
    const invite: any = data.invite

    let entity: InviteV2 = new InviteV2();
    entity.letter_id = letter.id;
    entity.letter_name = letter.name;
    entity.letter_subject = letter.subject;
    entity.letter_text = html_email;
    entity.event_id = event.id;
    entity.event_name = event.name;
    entity.member_id = invite.member_id;
    entity.member_name = invite.member_name;

    entity.member_email = member_email; // pode não existir e é por isso que tá registrando sem enviar email
    entity.date_sent = new Date();
    entity.date_response = null;
    entity.accept = false;
    entity.obs = obs;
    entity.admin_invite = admin_invite;
    entity.admin_response = false;

    entity.url_back = url_back;
    entity.type = letter.type;
    entity.agenda = invite.agenda;
    entity.memberDataCheck = memberDataCheck;

    return entity;
  }

  makeShipping (invites: any, letter: any, event: any) {

    if (invites) {

      invites.forEach((_invite) => {

        if (_invite.selected) { //&& !data.sent
          let invite: any = {}
          invite = _invite;
          // invite.event = event;
          console.log("invite.member_name: " + invite.member_name)

          const data: any = {
            'letter': letter,
            'event': event,
            'invite': invite
          }

          // console.log("invite data: " + JSON.stringify(data))

          this.registerInvite(data, true, "", false);
        }

      })
    }
  }

  registerInvite (data: any, hasEmail: boolean, obs: string, admin_invite: boolean): Promise<any> {

    return new Promise((resolve, reject) => {

      /// console.log("data.invite.member_id: " + JSON.stringify(data.invite.member_id))

      return this.db.doc<Member>('sbccv_members/' + data.invite.member_id)
        .get()
        .subscribe((member) => {

          let memberTemp: any = {};
          const email_crypto = this._cryptoService.set(this._cryptoService.key, member.data().email)
          const phone_crypto = this._cryptoService.set(this._cryptoService.key, member.data().cellPhone)
          const cpf_crypto = this._cryptoService.set(this._cryptoService.key, member.data().cpf)

          memberTemp = {
            'name': member.data().name,
            'email': email_crypto,
            'cellPhone': phone_crypto,
            'cpf': cpf_crypto,
            'text': member.data().text,
            'image': member.data().image,
            'imageChanged': false,
            'dateCreated': new Date(),
            'moved': false,
            'updated': false,
            'changed': false,
          }

          let url_back: string = this.makeURL(data);
          let html_email: string = this.makeEmail(data.invite, data.letter, url_back);
          let member_email = email_crypto//member.data().email
          let newInvite: InviteV2 = this.makeInvite(data, url_back, member_email, html_email, obs, admin_invite, memberTemp);

          let p_agenda: any[] = []

          newInvite.agenda.forEach((item) => {
            p_agenda.push(Object.assign({}, item))
          })
          newInvite.agenda = p_agenda

          //console.log("***************************")
          //console.log(JSON.stringify(newInvite))

          return this.db.collection('sbccv_invites_v2').add(Object.assign({}, newInvite))
            .then((result) => {

              console.log("convite registrado")

              newInvite.id = result.id
              if (hasEmail) {
                this.sendEmail(newInvite)
              }
              resolve(newInvite)

            })
            .catch((error) => {
              // this.snackBar.openSnackBar("Erro!", '', 'error')
              console.log("ERRO " + JSON.stringify(error.message));
              reject(error)
            })
            .finally(() => {
              //    this.snackBar.openSnackBar("Sucesso!", '', 'success')
            })

        })
    })
  }

  sendEmail (invite) {

    let email_plain = this._cryptoService.get(this._cryptoService.key, invite.member_email)

    // console.log("sendEmail member_name: " + invite.member_name)
    //  console.log("sendEmail member_email: " + email_plain)
    //  console.log("sendEmail letter_text: " + invite.letter_text)
    //console.log("-------------------------------------")

    return this._emailService.sendStandardEmail({
      'subject': invite.letter_subject,
      'html': invite.letter_text,
      'from': "SBCCV <cientifico@sbccv.org.br>",
      'to': email_plain,
      'bcc': "cientifico@sbccv.org.br, email.otero@gmail.com"
    })
      
  }

  formatDate (date: Date) {
    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  compareNames (a, b) {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  }
  
  async getEventsInContext (context_id: string): Promise<any[]> {
    const array: any[] = [];
    try {
      const querySnapshot = await this.db.collection<any>('sbccv_events', ref => ref
        .where("congress", "==", true)
        .where("context_id", "==", context_id))
        .get()
        .toPromise();

      querySnapshot.forEach((doc) => {
        // Adiciona cada documento ao array
        array.push(doc.id);
      });
      // Retorna o array após carregado
      return array;
    } catch (error) {
      console.error("Erro getEventsInContext: ", error);
      throw error;
    }
  }

  loadAgendaForInvites (event_id: any, letter_id: string) {

    return this.db.collection<Agenda>('sbccv_agenda', ref => ref
      .where('event_id', '==', event_id)
      .orderBy('member_name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        let arrayAgenda: any[] = result.map(item => {

          let agenda = new Agenda();
          agenda.id = item.payload.doc.id;
          agenda.requireConfirm = item.payload.doc.data().requireConfirm
          agenda.acceptInvite = false;
          agenda.member_id = item.payload.doc.data().member_id;
          agenda.member_name = item.payload.doc.data().member_name;
          agenda.event_id = item.payload.doc.data().event_id;
          agenda.event_name = item.payload.doc.data().event_name;
          agenda.day_id = item.payload.doc.data().day_id;
          let dt: any = item.payload.doc.data().day_date;
          agenda.day_date = new Date(dt.seconds * 1000);
          agenda.day_name = item.payload.doc.data().day_name;
          agenda.depto_id = item.payload.doc.data().depto_id;
          agenda.depto_name = item.payload.doc.data().depto_name;
          agenda.activity_id = item.payload.doc.data().activity_id;
          agenda.activity_name = item.payload.doc.data().activity_name;
          agenda.activity_startTime = item.payload.doc.data().activity_startTime;
          agenda.level = item.payload.doc.data().level;
          if (agenda.level == "t") {
            agenda.topic_id = item.payload.doc.data().topic_id;
            agenda.topic_name = item.payload.doc.data().topic_name;
            agenda.topic_startTime = item.payload.doc.data().topic_startTime;
            agenda.topic_duration = item.payload.doc.data().topic_duration;
          }
          agenda.role_id = item.payload.doc.data().role_id;
          agenda.role_name = item.payload.doc.data().role_name;

          return agenda;

        })

        arrayAgenda.forEach((ag) => {

          if (ag.level == "a") {
            //atividades
            let activities: any = arrayAgenda.filter((e) => {
              return e.activity_id == ag.activity_id
            })

            //equipe da atividade
            ag.activityStaff = []
            activities.forEach(el => {
              if (el.level == 'a') {
                ag.activityStaff.push({
                  'role_name': el.role_name,
                  'member_name': el.member_name
                })
              }
            });

            //tópicos da atividade
            ag.activityTopics = []
            activities.forEach(el => {
              if (el.topic_name) {
                let exist = ag.activityTopics.find((e) => {
                  return e.topic_name == el.topic_name && e.topic_startTime == el.topic_startTime
                })
                if (!exist) {
                  ag.activityTopics.push({
                    'topic_startTime': el.topic_startTime,
                    'topic_name': el.topic_name
                  })
                }
              }
            });
            ag.activityTopics.sort(this.compareTimes)

          } else if (ag.level == "t") {
            //tópicos
            let topics: any = arrayAgenda.filter((e) => {
              return e.topic_id == ag.topic_id
            })
            //equipe do tópico
            ag.topicStaff = []
            topics.forEach(el => {
              if (el.level == 't') {
                ag.topicStaff.push({
                  'role_name': el.role_name,
                  'member_name': el.member_name
                })
              }
            });

          }
        })

        //TEMOS OS DADOS DA AGENDA
        //PREPARA OS COVITES E VERIFICA QUEM JA FOI CONVIDADO
        this.checkInvites(arrayAgenda, event_id, letter_id)

      })

  }

  checkInvites (arrayAgenda, event_id, letter_id) {

    let invites: any[] = []

    this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where('event_id', '==', event_id)
      .where('letter_id', '==', letter_id)).snapshotChanges()
      .subscribe((result) => {

        result.forEach((item) => {
          // CAPTURA DATA DE ENVIO E DATA DE RESPOSTA
          let dt_sent: any = item.payload.doc.data().date_sent
          let dt_response: any = item.payload.doc.data().date_response

          //PREPARA O ITEM SER APRESRENTADO NA LISTA
          let entity = {
            'id': item.payload.doc.id,
            'event_id': item.payload.doc.data().event_id,
            'letter_id': item.payload.doc.data().letter_id,
            'member_id': item.payload.doc.data().member_id,
            'accept': item.payload.doc.data().accept,
            'date_sent': dt_sent ? new Date(dt_sent.seconds * 1000) : "",
            'date_response': dt_response ? new Date(dt_response.seconds * 1000) : "",
            'obs': item.payload.doc.data().obs,
            'admin_invite': item.payload.doc.data().admin_invite,
            'admin_response': item.payload.doc.data().admin_response,
            // 'type': item.payload.doc.data().type,
            'url_back': item.payload.doc.data().url_back
          }
          //COLECIONA O ITEM
          invites.push(entity)
        })

        //PREPARA A TABELA A SER APRESENTADA
        this.makeTable(invites, arrayAgenda)
      })
  }

  makeTable (invites, arrayAgenda) {

    let arrayInvite: any[] = [];
    let current_member: string = ""
    let members: any[] = [];

    arrayAgenda.forEach(element => {

      if (current_member != element.member_name) {
        current_member = element.member_name
        members.push({
          'member_id': element.member_id,
          'member_name': element.member_name,
          'member_email': element.member_email
        })
      }

    });

    members.forEach((item) => {

      let agenda: any[] = arrayAgenda.filter((e) => {
        return e.member_id == item.member_id
      })

      agenda.sort(this.compareAppointments)
      //console.log('agenda: ' + JSON.stringify(agenda))

      let requireConfirmAll: boolean = true;

      agenda.forEach((item) => {
        if (!item.requireConfirm) {
          requireConfirmAll = false
        }

      })

      let inviteExist = invites.find((e) => {
        return e.member_id == item.member_id
      })

      let flag: boolean = false
      if (inviteExist) {
        flag = true
        // console.log("inviteExist.member_name: " + JSON.stringify(inviteExist))
      }

      //   console.log("inviteExist: " + JSON.stringify(inviteExist))
      arrayInvite.push({
        'id': inviteExist ? inviteExist.id : "",
        'date': new Date(),
        'member_id': item.member_id,
        'member_name': item.member_name,
        'member_email': item.member_email,
        'agenda': agenda,
        'requireConfirmAll': requireConfirmAll,
        'selected': false,
        'sent': flag,
        'date_sent': inviteExist ? inviteExist.date_sent : "",
        'accept': inviteExist ? inviteExist.accept : false,
        'date_response': inviteExist ? inviteExist.date_response : "",
        'obs': inviteExist ? inviteExist.obs : "",

        'admin_invite': inviteExist ? inviteExist.admin_invite : false,
        'admin_response': inviteExist ? inviteExist.admin_response : false,

        'type': inviteExist ? inviteExist.type : "0",
        "url_back": inviteExist ? inviteExist.url_back : ""
      })

    })

    // console.log(JSON.stringify(arrayInvite))

    this.invitesDataSource = new MatTableDataSource(arrayInvite);

  }

  compareTimes (a, b) {
    let pa: string = a.topic_startTime;
    let pb: string = b.topic_startTime;
    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;
  }

  compareAppointments (a, b) {
    let dt_a: Date = new Date(a.day_date)
    let dt_b: Date = new Date(b.day_date)

    const pa = dt_a.getTime().toString() + a.activity_startTime + a.topic_startTime
    const pb = dt_b.getTime().toString() + b.activity_startTime + b.topic_startTime

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;
  }

  ////////////////////////////////

  updateMemberData (data, member_id) {

    let updateMember: any = {}
    updateMember.id = member_id
    updateMember.name = data.name
    updateMember.email = data.email
    updateMember.cellPhone = data.cellPhone
    updateMember.text = data.text
    updateMember.updated = false
    updateMember.dateCreated = new Date()

    // console.log("updateMember: " + JSON.stringify(updateMember))

    this.db.collection('sbccv_members_temp').doc(member_id).set(Object.assign({}, updateMember))
      .then(() => {

        if (this.objectImage) {
          console.log('TEM IMAGEM')
          this.uploadImage(this.objectImage, member_id, updateMember)
        } else {
          console.log('NAO TEM IMAGEM')
          this.sendEmailMemberUpdate(updateMember)
        }

      })
      .catch(() => {console.log("update member erro 685")})

  }

  sendEmailMemberUpdate (updateMember: any, image: string = null) {

    let html = ''
    html += '<div>'

    if (image) {
      html += '<p>' + image + '</p>'
    }

    html += '<p>' + updateMember.name + '</p>'
    html += '<p>' + updateMember.email + '</p>'
    html += '<p>' + updateMember.cellPhone + '</p>'
    html += '<p>' + updateMember.text + '</p>'

    html += '</div>'

    let mailOptions: any = {
      'subject': 'SBCCV Atualização: ' + updateMember.name,
      'html': html,
      'from': 'SBCCV <cientifico@sbccv.org.br>',
      'to': 'sandra@sbccv.org.br',
      'bcc': ''
    }

    //  console.log("mailOptions: " + JSON.stringify(mailOptions))

    this._emailService.sendStandardEmail(mailOptions)
      .then(() => {
        console.log("email enviado")
        this.router.navigate([ 'invite_end' ]);
      })
      .catch(() => {
        console.log("erro ao enviar email 698")
      })

  }

  decryptData (memberDataCheck: any) {
    memberDataCheck.email = this._cryptoService.get(this._cryptoService.key, memberDataCheck.email)
    memberDataCheck.cellPhone = this._cryptoService.get(this._cryptoService.key, memberDataCheck.cellPhone)
    return memberDataCheck
  }

  createMemberForm (member) {

    console.log()
    if (member.image)
      this.storedImage = 'assets/images/geral/photoURL.png'//member.image
    else
      this.storedImage = 'assets/images/geral/photoURL.png'

    this.memberForm = this.fb.group({
      id: new FormControl(member.id),
      name: new FormControl(member.name),
      email: new FormControl(member.email),
      cellPhone: new FormControl(member.cellPhone),
      text: new FormControl(member.text),
      image: new FormControl(member.image)
    });
  }

  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage (file, member_id, updateMember) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/members_temp/" + member_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {

          this.updateImage(member_id, url, updateMember)
            .then((result) => {
              this.memberForm.controls.image.setValue(result);
            })

        });
      }))
      .subscribe();
  }

  updateImage (member_id: any, url: any, updateMember: any) {
    return this.db.collection('sbccv_members_temp').doc(member_id).set({'image': url, 'imageUpdate': false}, {merge: true})
      .then(() => {
        this.objectImage = ""
        this.sendEmailMemberUpdate(updateMember, url)
        return url;
      })
      .catch((err) => {
        console.log("erro upadate member temp image: " + JSON.stringify(err))
      })
  }

  archiveInvite (id: string, flag: boolean) {
    return this.db.collection('sbccv_invites_v2').doc(id).update({'archived': !flag});
  }

}